export const aiGradient = 
  'linear-gradient(90deg, #4700B2 0%, #5A257D 100%)';

  export const darkPurple = '#4700B2';